<template>
    <tr :style="conditionalBorder"> 
        <td>{{ row.guide.full_name  }}</td>
        <td>{{ this.$moment(row.day).format("DD/MM/YYYY") }}</td>
        <td>{{ row.excursion }}</td>
        <td>{{ row.bus.name }}</td>
        <td>{{ row.bus.max_size }}</td>
        <td>{{ row.bus.count_adults }}</td>
        <td>{{ row.bus.count_children }}</td>
        <td>{{ row.bus.count_adults + row.bus.count_children }}</td>
        <td>{{ row.duration_name}} ({{row.duration_code}})</td>
        <td>{{ transformed_price }}</td>
    </tr>
</template>

<script>
/* eslint-disable */

import {Fragment} from 'vue-fragment'
export default {
    components: {
        Fragment
    },
    props: {
        row: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: true,
        },
        all: {
            type: Array,
            required: true
        }
    },
    computed: {
        transformed_price() {
            if ( this.row.price == null ) {
                return null
            }
            if ( this.row.price.includes('.') ) {
                return this.row.price.replace('.', ',') + " €"
            }
            return this.row.price
        },
        conditionalBorder() {
            if ( this.idx > 0 && this.all[this.idx-1].guide.full_name !== this.row.guide.full_name ) {
                return 'border-top: 1px solid #999;'
            }
        }
    }
}
</script>